export { default } from './LargeImageThumbnail';
